import { Skeleton } from "@/core/components/ui/skeleton";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";

interface PaymentsSummaryInfoProps {
  value?: React.ReactNode;
  label?: React.ReactNode;
  date?: React.ReactNode;
  show?: boolean;
  isLoading?: boolean;
}

export const PaymentsSummaryInfo = ({
  value,
  label,
  date,
  isLoading,
  show = true,
}: PaymentsSummaryInfoProps) => {
  if (isLoading) {
    return (
      <Stack className="p-3 pl-4 pr-8" gap="none">
        <Skeleton className="h-6 w-[120px]" />
        <Skeleton className="mt-2 h-4 w-[100px]" />
      </Stack>
    );
  }

  if (!show) {
    return null;
  }

  return (
    <Stack className="p-3 pl-4 pr-8" gap="none">
      <Stack direction="row" gap="md" align="center" className="h-[32px]">
        <Typography variant="subtitleW2">{value}</Typography>
        <Typography variant="bodyW2" textColor="tertiary">
          {date}
        </Typography>
      </Stack>
      <Typography variant="subtitleW3" textColor="tertiary">
        {label}
      </Typography>
    </Stack>
  );
};
